export default __webpack_public_path__ + "static/media/4_2.78c99894.jpg";